<template>
  <div class="min-h-screen bg-light flex flex-col">
    <AppHeader />
    <main class="flex-1">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import { onMounted } from 'vue'
import { useAppStore } from '@/stores'

const store = useAppStore()

onMounted(() => {
  store.initLocale()
})
</script>
